import React from 'react'
import { Badge } from '@plurall/elo-beta'
import styles from './SchoolData.module.scss'
import PropTypes from 'prop-types'
import {
  ROLE_ADMIN_ID,
  ROLE_DIRECTOR_ID,
  ROLE_STATUS_DISAPPROVED_ID,
  ROLE_STATUS_PENDING_ID,
} from 'utils'

const Position = {
  [ROLE_STATUS_PENDING_ID]: {
    variant: 'attention',
    text: 'Aguardando aprovação.',
  },
  [ROLE_STATUS_DISAPPROVED_ID]: {
    variant: 'negative',
    text: 'Função não aprovada. Entre em contato com o gestor da sua escola.',
  },
}

const Roles = {
  [ROLE_ADMIN_ID]: 'admin',
  [ROLE_DIRECTOR_ID]: 'director',
}

const RoleStatus = ({ roleID, status }) => {
  if (status !== ROLE_STATUS_PENDING_ID && status !== ROLE_STATUS_DISAPPROVED_ID) {
    return <></>
  }
  const roleName = Roles[roleID]
  return (
    <div className={styles['role-status']}>
      {status && (
        <Badge dataTestId={`badge-status-${roleName}`} variant={Position[status].variant}>
          {Position[status].text}
        </Badge>
      )}
    </div>
  )
}

RoleStatus.propTypes = {
  status: PropTypes.string,
  roleID: PropTypes.number,
}

export { RoleStatus }
